export const handleAnimationOn = (direction) => {
    const el = document.querySelector(".Button-ok");
    const classEl = `Button-ok-${direction}`;
    el.classList.add(classEl);

};

export const handleAnimationOff = (direction) => {
    const el = document.querySelector(".Button-ok");
    const classEl = `Button-ok-${direction}`;
    el.classList.remove(classEl);
};